export enum TransportOrderOfferStatus {
  Active,
  Inactive,
  Finished
}
